import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-finance-header',
  templateUrl: './finance-header.component.html',
  styleUrls: ['./finance-header.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class FinanceHeaderComponent {
  @Input() user: any;
  @Input() dealer: any;
  
  constructor() { }

  getInitials(): string {
    return this.user && this.user.firstName && this.user.lastName ? 
      this.user.firstName.charAt(0) + this.user.lastName.charAt(0) : 'FU';
  }

  logout(): void {
    // Emit an event to parent component to handle logout
    const event = new CustomEvent('logout');
    window.dispatchEvent(event);
  }
}
